export default "__VITE_ASSET__8H30xBjX__"